exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".counter__counter___3Ykru {\n  color: #ffffff;\n  font-size: 14px;\n  opacity: 0.63;\n  border-radius: 17.5px;\n  background-color: #141414;\n  padding: 8.5px 17.5px; }\n", ""]);

// exports
exports.locals = {
	"counter": "counter__counter___3Ykru"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/IndexCarousel/Counter/counter.scss
// module id = 2038
// module chunks = 6